import { render, staticRenderFns } from "./ResultadoInscripcion.vue?vue&type=template&id=5ae00978&"
import script from "./ResultadoInscripcion.vue?vue&type=script&lang=js&"
export * from "./ResultadoInscripcion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports